import { SlDrawer } from "@shoelace-style/shoelace/dist/react";
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import API from "../../services/api";
import { Toast } from "../../shared/Toast";
import Select from "react-select";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import LineitemPreview from "../campaign/LineitemPreview";
import { DESIGN_OPTIONS, fetchMatchAdCodeAlert, getOverlapStatus, slotOptions } from "../../utils/constants";

const TYPE_OPTIONS = [
  { label: "Panel Ads / GAM Internal Ads", value: "panel" },
  { label: "GAM", value: "gam" },
];

const SOURCE_OPTIONS = [
  { label: "Google", value: "google" },
  { label: "Facebook", value: "fb" },
];
const SUBTYPE_OPTIONS = [
  { label: "GAM External", value: "gam_external" },
  { label: "Ad mob", value: "admob" },
];
const RECADTYPE_OPTIONS = [
  { label: "GAM Internal", value: "gamInternal" },
  { label: "GAM External", value: "gamExternal" },
  { label: "Panel", value: "panel"}
];
const RECADPOSITION_OPTIONS = [
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
];
const source_options = {
  google: "Google",
  fb: "Facebook",
};
const ADTYPE_OPTIONS = [
  {
    label: "Native",
    value: "Native",
  },
  { label: "Native Advanced", value: "Native Advanced" },
];
const OTHER_AD_TYPES =[
  {label:"Native Ad",value:"1"},
  // {label:"Interstitial Ad",value:"2"}
  {label:"Banner Ad",value:"3"},
  {label:"Native + Banner Ad",value:"4"},
]
const deisgn_options = {
  1: "Design (old)",
  2: "Button Center",
  3: "Button Right",
  4: "Button Full",
  5: "Full Page"
};
const otherAdSrcs = [
  { label: "Magic Bid", value: "mbid" },
  // { label: "Direct-Nimbus", value: "dir_nmb" },
  // { label: "GAM-Nimbus", value: "gm_nmb" },
  { label: "GAM-Amazon", value: "gm_amz" },
  // { label: "GAM-Amazon-Nimbus", value: "gm_amz_nmb" },
  // { label: "GAM-Amazon+Nimbus", value: "gm_amz_nmb1" },
  { label: "VDO", value: "vdo" },
];

const otherAdsrcs8_87 =  [
  {label:"Applovin", value:"applovin"},
  // { label: "Applovin-Amazon", value: "applovin_amz" },
  // {label:"GAM + Applovin", value:"gamapplovin"}
  ]



const labelNames = {
  mbid: "Magic Bid",
  // dir_nmb: "Direct-Nimbus",
  vdo: "VDO",
  google: "GAM",
  // gm_nmb: "GAM-Nimbus",
  gm_amz: "GAM-Amazon",
  // gm_amz_nmb: "GAM-Amazon-Nimbus",
  // gm_amz_nmb1: "GAM-Amazon+Nimbus",
};

const labelNames8_87 = {
  applovin:"Applovin",
  applovin_amz:"applovin_amz"
}
const POSITION_OPTIONS = [];
for (let i = 0; i < 101; i++) {
  POSITION_OPTIONS.push({ label: i, value: i });
}

const BANNER_SIZE_OPTIONS = [
  { label: "Single 300X250", value: "300x250" },
  { label: "Single 300X600", value: "300x600" },
  { label: "Single 320X480", value: "320x480" },
  { label: "Single 640X480", value: "640x480" },
  { label: "Single 1080X1776", value: "1080x1776" },
  // { label: "Single 420x900", value: "420x900" },
  // { label: "Single 360x780", value: "360x780" },
  // { label: "Single 380x800", value: "380x800" },
  // { label: "Single 400x820", value: "400x820" },
  // { label: "Single 380x820", value: "380x820" },
  { label: "Single 380x780", value: "380x780" }
]

// Full-screen banner sizes that have no Top/Bottom placement.
const FULL_SCREEN_BANNER_SIZES = [
  // "420x900", "360x780", "380x800", "400x820", "380x820", 
  "380x780"];

const SLOT_OPTIONS = [
  { label: "None", value: "3" },
  { label: "Slot A", value: "0" },
  { label: "Slot B", value: "1" },
  { label: "Slot C", value: "2" },

]

const DESIGN_FORMAT_OPTIONS = [
    { label: "Image", value: "1" },
  { label: "Video", value: "2" },
]

const PREBID_OPTIONS =[
  {label:"None", value:'0'},
      { label: "Ascendum", value: "1" },
  { label: "Limelight", value: "2" },
]

const DESIGN_TYPE_OPTIONS =[
  {label:"Horizontal", value:"1"},
  {label:"Vertical", value:"2"},
]

const POSITION_OPTIONS_RADIO = [
  {label:"Top", value:"1"},
  {label:"Bottom", value:"2"},
]

const OPERATING_SYSTEMS = [
  {label:"All", value:"0"},
  {label:"Android", value:"1"},
  {label:"Ios", value:"2"},
]

const BACKFILL_SOURCE= [
  {label:"Geeme", value:'1'},
  {label:"Appnext", value:'2'}
]

function AddPosition(props) {
  const [positionData, setPositionData] = useState([]);
  const [submitClicked, setSubmitClicked] = useState(false);
  const [bannerSource, setBannerSource] = useState({
    label: "Google",
    value: "google",
  });
  const [formSubmit, setFormSubmit] = useState(false);
  const [formData, setFormData] = useState();
  const [matchAdCodeAlert, setMatchAdCodeAlert] = useState({});
  const [adPartners,setAdPartners]= useState([])
  const [enabledPositionSlots, setEnabledPositionSlots] = useState([0,1,2,3]);

  const filteredTypeOptions = props.backfill
    ? TYPE_OPTIONS.filter((option) => option.value !== "gam")
    : TYPE_OPTIONS;
  const [netId, setNetId] = useState();
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const handleClose = () => {
    form1.reset();
    props.setShow(false);
    props.setPosition(false);
    props.fetchAds(0, props.target_filter);
    props.setGam(false);
    props.setBackfill(false);
    props.setEditFlag(false);
    setFormSubmit(false);
    setPreviewCampaignId(null)
  };

  const form1 = useForm({
    mode: "all",
    defaultValues: { net_state_ids: [], net_district_ids: [], recads: [] },
  });

  const watchPosition = form1.watch("position");
  let watchType = form1.watch("type");
  let watchSlot = form1.watch("slot", "0");
  if (props.gam) {
    const type = form1.getValues("type");
    if (type?.value !== "gam")
      form1.setValue("type", { label: "GAM", value: "gam" });
    watchType = form1.watch("type", { label: "GAM", value: "gam" });
  }
  let watchAdType = form1.watch("adType");
  let watchChecked = form1.watch("backfill", props.backfill);
  let watchBanner = form1.watch("bannerAd");
  let watchRecAds = form1.watch("recads");
  let watchGambackFill = form1.watch("gamBackfill");
  let watchGambackFill8_87 = form1.watch("gamBackfill8_87");

  let watchDesignType = form1.watch('designType')
  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [previewCampaignId, setPreviewCampaignId] = useState(null)
  const [recPosWiseLineitemOptions, setRecPosLineitemOptions] = useState([])

  const fetchAds = async () => {
    try {
      let res = await API({
        url: "/adunit/PositionalAds",
        method: "POST",
        responseType: "json",
        data: {
          target_filter: props.target_filter,
          position: watchPosition ? watchPosition?.value : props.position,
          backfill: props?.backfill ? props.backfill : false,
          slot: props.slot || watchSlot,
        },
      });
      if (res.code === 200) {
        setPositionData(res.data?.final_campaigns);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
     const fetchAdPartners = async() => {
        const result= await API({
          url:'/adpartners/getAdPartnersNames',
          method:"POST"
        })
        setAdPartners(result.data);
     }
     fetchAdPartners();
  },[])

  useEffect(() => {
    const fetchEnabledPositionSlots = async() => {
      if(watchType && watchType?.value === 'panel'){
        console.log(watchSlot)
        form1.setValue("slot", null);
        const result = await API({
          url: "/adunit/getPositionEnabledSlots",
          method: "POST",
          data: {
            lang_id: props.target_filter.lang_id,
            position: watchPosition?.value,
          },
        });
        if(result.code === 200){
          setEnabledPositionSlots(result.data);
        }
      }
      else{
        setEnabledPositionSlots([0,1,2,3]);
      }
    }
    fetchEnabledPositionSlots();
  },[props.target_filter.lang_id,watchPosition,watchType]);
 
  // Prefill partner selects in edit mode once partners are available
  useEffect(() => {
    if (!props.editFlag) return;
    if (!props.editData) return;
    if (!adPartners || adPartners.length === 0) return;
    const data = props.editData;
    const findOpt = (val) => adPartners.find((o) => o.value === val) || null;
    // Native ad code partner
    if (data.ad_code_partner !== undefined && data.ad_code_partner !== null) {
      form1.setValue("adCode_partner", findOpt(data.ad_code_partner));
    }
    // Banner partner
    if (data.banner_code_partner !== undefined && data.banner_code_partner !== null) {
      form1.setValue("banner_code_partner", findOpt(data.banner_code_partner));
    }
    // Other source partner (8.50)
    if (data.other_ad_code_partner !== undefined && data.other_ad_code_partner !== null) {
      form1.setValue("other_ad_code_partner", findOpt(data.other_ad_code_partner));
    }
    // Backfill partner
    if (data.backfill_gam_code_partner !== undefined && data.backfill_gam_code_partner !== null) {
      form1.setValue("backfill_gam_code_partner", findOpt(data.backfill_gam_code_partner));
    }
    // 8.87/8.88 ad code partner
    if (data.ad_code_8_87_partner !== undefined && data.ad_code_8_87_partner !== null) {
      form1.setValue("other_ad_code8_87_partner", findOpt(data.ad_code_8_87_partner));
    }
    // Recads partners
    if ((data.isbannerad || data.other_ad_type) && Array.isArray(data.recads) && data.recads.length) {
      const currentRecads = form1.getValues("recads") || [];
      const updated = currentRecads.map((r, idx) => {
        const pid = data.recads[idx]?.ad_code_partner;
        return {
          ...r,
          ad_code_partner: pid !== undefined && pid !== null ? findOpt(pid) : r?.ad_code_partner,
        };
      });
      form1.setValue("recads", updated);
    }
  }, [adPartners, props.editFlag, props.editData]);

  function getHiddenvalue(targetValue) {
    const foundObject = positionData.find(
      (obj) => parseInt(obj.value) === parseInt(targetValue)
    );
    console.log(foundObject, targetValue);
    if (foundObject) {
      return foundObject.hidden;
    } else {
      return null; // Or handle the case when the value is not found
    }
  }
  const dummySubmit = async (data) => {
    setPreviewCampaignId(data.adName?.value)
    setMatchAdCodeAlert(await fetchMatchAdCodeAlert({campaign_id: data.adName?.value,ad_codes: [data.adCode, data.banner_code, data.other_ad_code, data.other_ad_code8_87].filter(i => i), lang_id: +props?.target_filter?.lang_id || 1, net_id: netId || null, slot: props.slot || watchSlot, position: watchPosition ? watchPosition?.value : props.position }));
    setFormData(data);
    setSubmitClicked(true);
  };

  const onSubmit = async (data) => {
    let flag = true;
    console.log(data);
    let recads = data.recads;
    recads = recads.map((item) => {
      return {
        type: item.type.value,
        ad_code: item.type.value === 'panel' ? null : item.ad_code,
        ad_code_partner: item.type.value === 'panel' ? null : (item.ad_code_partner?.value || null),
        rec_position: item.rec_position.value,
        campaign_id: item.type.value === 'panel' ? item.campaign_id?.value : null,
      };
    });
    if (flag) {
      data.position =
        props.position || props.position === 0
          ? props.position
          : data.position?.value;
      data.type.value = props.gam ? "gam" : data.type.value;
      console.log(data.checkbox, data.checkbox1, data.checkbox18_87)
      try {
        let res = await API({
          url: "/adunit/publishUnit",
          method: "POST",
          responseType: "json",
          data: {
            campaign_id:
              data.type.value === "panel" ? data.adName.value : undefined,
            ad_type: data.type.value,
            source: data.type.value !== "panel" ? data.adType.value : undefined,
            sub_type:
              data.type.value !== "panel" ? data.subType.value : undefined,
            backfill: data.backfill || props.backfill,
            native_type:
              data.type.value !== "panel"
                ? data.adType.value !== "google"
                  ? "Native"
                  : "Native Advanced"
                : undefined,
            ad_name: data.type.value !== "panel" ? data?.adName : undefined,
            lang_id: props.target_filter.lang_id,
            position: data.position,
            ad_code: data.adCode,
            ad_code_partner: data.adCode_partner?.value || null,
            rotation: data.rotation ? 1 : 0,
            action: 1,
            design_type:
              data.type.value !== "panel" ? data.designType.value : undefined,
            banner_code: data.bannerAd ? data.banner_code : "",
            banner_code_partner: data.bannerAd ? (data.banner_code_partner?.value || null) : null,
            cachead: 1,
            banner_src: bannerSource.value,
            banner_size: data.bannerAd ? data.checkbox.join(",") : "",
            net_id: props.editFlag ? netId : undefined,
            placement: onlyFullScreenBanner ? null : (data.placement || null),
            news_display: data.news_display || null,
            hidden:
              data.type.value === "panel"
                ? getHiddenvalue(data.adName?.value)
                : 0,
            other_ad_code:['vdo','gm_nmb','gm_amz_nmb1','gm_amz_nmb','gm_amz','google'].includes(selectedOtherAdSrc?.value) ? (data.other_ad_code || null) : null,

            other_ad_code_partner:
             ['vdo','gm_nmb','gm_amz_nmb1','gm_amz_nmb','gm_amz','google'].includes(selectedOtherAdSrc?.value) ? (data.other_ad_code_partner?.value || null) : null,
            other_slotuuid:
              ((selectedOtherAdType === "3" || selectedOtherAdType === '4')&&
                (selectedOtherAdSrc?.value === "gm_amz_nmb" ||
                  selectedOtherAdSrc?.value === "gm_amz_nmb1" ||
                  selectedOtherAdSrc?.value === "gm_amz") &&
                data.other_slotuuid) ||
              null,
            other_ad_type: watchOtherAd ? selectedOtherAdType || null : null,
            other_source: watchOtherAd
              ? selectedOtherAdSrc?.value || null
              : null,
            other_banner_size:
              (selectedOtherAdType === "3" || selectedOtherAdType === "4") ? data.checkbox1.join(",") : null,
            slot:
              data.backfill || props.backfill
                ? 3
                : data.slot ? data.slot : 3,
            net_state_ids: data.net_state_ids?.length
              ? data.net_state_ids.map((item) => item.state_id)
              : [],
            net_district_ids: data.net_district_ids?.length
              ? data.net_district_ids.map((item) => item.dist_id)
              : [],
            os: data.os,
            top_mar: data.top_mar || null,
            btm_mar: data.btm_mar || null,
            recads:
                (data.type.value !== "panel" &&
                  watchBanner &&
                  Array.isArray(selectedBannerSize) &&
                  selectedBannerSize.length === 1 &&
                  selectedBannerSize[0] === "300x250") ||
                (watchOtherAd &&
                  Array.isArray(selectedBannerSize1) &&
                  selectedBannerSize1.length === 1 &&
                  selectedBannerSize1[0] === "300x250")
                  ? recads
                  : [],
            backfill_gam_code: watchGambackFill
              ? data.backfill_gam_code
              : undefined,
            backfill_gam_code_partner: watchGambackFill
              ? (data.backfill_gam_code_partner?.value || null)
              : undefined,
            backfill_gam_src8_87:watchGambackFill8_87 ? data.backfill_gam_src8_87 :null,
            
              ad_code_8_87:
              ((
                selectedOtherAdSrc8_87?.value === "applovin_amz" ||
                selectedOtherAdSrc8_87?.value === "applovin") &&
                data.other_ad_code8_87) ||
              null,
              ad_code_8_87_partner:
              ((
                selectedOtherAdSrc8_87?.value === "applovin_amz" ||
                selectedOtherAdSrc8_87?.value === "applovin") &&
                data.other_ad_code8_87_partner?.value) ||
              null,
              slotuuid_8_87:
              (selectedOtherAdType8_87 === "3" &&
                (
                  selectedOtherAdSrc8_87?.value === "applovin_amz") &&
                data.other_slotuuid8_87) ||
              null,
              ad_type_8_87: watchOtherAd8_87 ? selectedOtherAdType8_87 || null : null,
              source_8_87: watchOtherAd8_87
              ? selectedOtherAdSrc8_87?.value || null
              : null,
              banner_size_8_87:
              selectedOtherAdType8_87 === "3" ? data.checkbox18_87.join(",") : null,
              prebid:(selectedOtherAdSrc?.value === "gm_amz" ||
              selectedOtherAdSrc?.value === "google") ? data.prebid : 0 ,
              full_scr_type:data?.designType?.value === 5  ? data.full_scr_type : null
          },
        });
        if (res.code === 200) {
          handleClose();
          Toast("success", "Position added Successfully!");
        } else {
          Toast("error", res?.data?.message);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setFormSubmit(false);
        setSubmitClicked(false);
        props.fetchAds(0, props.target_filter);
      }
    } else {
      Toast("error", "Limit Reached to add");
    }
  };

  useEffect(() => {
    if (watchType?.value === "panel") {
      fetchAds();
    }
    if (!props.editFlag) form1.setValue("adName", "");
  }, [watchType, watchSlot]);

  //Other Source Constants
  let watchOtherAd = form1.watch("otherAd", false);
  let selectedOtherAdType = form1.watch("otherAdType", 0);
  let selectedOtherAdSrc = form1.watch("otherAdSrc", "");
  let selectedBannerSize = form1.watch("checkbox");
  let selectedBannerSize1 = form1.watch("checkbox1");

  let watchOtherAd8_87 = form1.watch("otherAd8_87", false);
  let selectedOtherAdType8_87 = form1.watch("otherAdType8_87", 0);
  let selectedOtherAdSrc8_87 = form1.watch("otherAdSrc8_87", "");

  let selectedBannerSize18_87 = form1.watch("checkbox18_87");
  // 420x900 / 360x780 are full-screen formats with no Top/Bottom placement. When only such
  // sizes are picked across every active section, hide the placement selector and store null.
  const asSizeArray = (v) => (Array.isArray(v) ? v : v ? [v] : []);
  const activeBannerSizes = [
    ...(watchBanner ? asSizeArray(selectedBannerSize) : []),
    ...(watchOtherAd ? asSizeArray(selectedBannerSize1) : []),
    ...(watchOtherAd8_87 ? asSizeArray(selectedBannerSize18_87) : []),
  ];
  const onlyFullScreenBanner = activeBannerSizes.length > 0 && activeBannerSizes.every((s) => FULL_SCREEN_BANNER_SIZES.includes(s));

  useEffect(() => {
    if (onlyFullScreenBanner) {
      form1.unregister("placement");
    }
  }, [onlyFullScreenBanner]);

  // Partner-required validators: watch code fields
  const watchAdCode = form1.watch("adCode");
  const watchBannerCode = form1.watch("banner_code");
  const watchOtherAdCode = form1.watch("other_ad_code");
  const watchBackfillGamCode = form1.watch("backfill_gam_code");
  const watchOtherAdCode8_87 = form1.watch("other_ad_code8_87");

  const getSoruces = () =>{
    if(selectedOtherAdType8_87 !== '3' ){
      return otherAdsrcs8_87.filter(option => option.value !== 'applovin_amz')
    }
    else{
      return otherAdsrcs8_87
    }
  }

  const NativeAdsOptions = [
    { label: "Magic Bid", value: "mbid" },
    // { label: "Direct-Nimbus", value: "dir_nmb" },
    { label: "VDO", value: "vdo" },
  ];

  const InterstitialAd = [
    // { label: "Direct-Nimbus", value: "dir_nmb" }
  ];

  const NativeBanner = [{ label: "GAM", value: "google" },  { label: "GAM-Amazon", value: "gm_amz" }];

  useEffect(() => {
    if (props.editFlag === true) {
      const data = props.editData;
      form1.setValue("adCode", data.ad_code);
      form1.setValue("adName", data.ad_name);
      if(data.slot<=3){
        form1.setValue('slot',`${data.slot}`)
      } 
      form1.setValue("designType", {
        value: data.design_type,
        label: deisgn_options[data.design_type],
      });
      if(data.design_type === 5){
        form1.setValue('full_scr_type', `${data.full_scr_type}`)
      }
      let watchDesign = form1.watch("designType", {
        value: data.design_type,
        label: deisgn_options[data.design_type],
      });
      watchAdType = form1.watch("adType", {
        value: data.source,
        label: source_options[data.source],
      });
      form1.setValue("adType", {
        value: data.source,
        label: source_options[data.source],
      });
      if (data.isbannerad === 1) {
        watchBanner = form1.watch("bannerAd", true);
        form1.setValue("bannerAd", true);
        form1.setValue("cachead", data.cachead);
        const bannerSizes = typeof data.banner_size === 'string'
      ? data.banner_size.split(',').map(s => s.trim())
      : data.banner_size;
    form1.setValue("checkbox", bannerSizes);

        setBannerSource({
          value: data.banner_src,
          label: source_options[data.banner_src],
        });
        form1.setValue("banner_code", data.banner_code);
      }
      watchChecked = form1.watch("backfill", data.backfill);
      form1.setValue("backfill", data.backfill);
      setNetId(data.net_id);
      form1.setValue("subType", {
        label: data.sub_type === "admob" ? "Ad mob" : "GAM External",
        value: data.sub_type,
      });
      if (data.placement) {
        form1.setValue("placement", `${data.placement}`);
      }
      if (data.news_display && data.news_display <= 2) {
        form1.setValue("news_display", `${data.news_display}`);
      }
      if (data.other_ad_type) {
        form1.setValue("otherAd", true);
        form1.setValue("otherAdType", `${data.other_ad_type}`, {
          shouldValidate: true,
        });
        form1.setValue(
          "otherAdSrc",
          { value: data.other_source, label: labelNames[data.other_source] },
          { shouldValidate: true }
        );
        const otherBannerSizes = typeof data.other_banner_size === 'string'
      ? data.other_banner_size.split(',').map(s => s.trim())
      : data.other_banner_size;
    form1.setValue("checkbox1", otherBannerSizes);
        if (data.other_ad_code) {
          form1.setValue("other_ad_code", data.other_ad_code);
        }
        if (data.other_slotuuid) {
          form1.setValue("other_slotuuid", data.other_slotuuid);
        }
        if(data.prebid != null){
          form1.setValue('prebid', `${data.prebid}`)
        }
      }
      if (data.ad_type_8_87) {
        form1.setValue("otherAd8_87", true);
        form1.setValue("otherAdType8_87", `${data.ad_type_8_87}`, {
          shouldValidate: true,
        });
        form1.setValue(
          "otherAdSrc8_87",
          { value: data.source_8_87, label: labelNames8_87[data.source_8_87] },
          { shouldValidate: true }
        );
        const bannerSizes8_87 = typeof data.banner_size_8_87 === 'string'
      ? data.banner_size_8_87.split(',').map(s => s.trim())
      : data.banner_size_8_87;
    form1.setValue("checkbox18_87", bannerSizes8_87);
    
    if (data.ad_code_8_87) {
      form1.setValue("other_ad_code8_87", data.ad_code_8_87);
    }
    if (data.slotuuid_8_87) {
      form1.setValue("other_slotuuid8_87", data.slotuuid_8_87);
    }
        if (data.ad_code_8_87) {
          form1.setValue("other_ad_code8_87", data.ad_code_8_87);
        }
        if (data.slotuuid_8_87) {
          form1.setValue("other_slotuuid8_87", data.slotuuid_8_87);
        }
      }
      if (data.net_state_ids) {
        setfield(data.net_state_ids, "net_state_ids");
      }
      if (data.net_district_ids) {
        setfield(data.net_district_ids, "net_district_ids");
      }
      if (data.os) {
        form1.setValue("os", `${data.os}`);
      }
      if (data.top_mar) {
        form1.setValue("top_mar", `${data.top_mar}`);
      }
      if (data.btm_mar) {
        form1.setValue("btm_mar", `${data.btm_mar}`);
      }
      if ((data.isbannerad || data.other_ad_type) && data.recads?.length) {
        let recads = data.recads;
        recads = recads.map((item) => {
          return {
            type: RECADTYPE_OPTIONS.find(
              (typeitem) => typeitem.value === item.type
            ),
            ad_code: item.ad_code,
            rec_position: RECADPOSITION_OPTIONS.find(
              (positem) => positem.value === item.rec_position
            ),
            campaign_id: data.recadsOptions.find(option => option.value === item.campaign_id),
          };
        });
        form1.setValue("recads", recads);
        setRecPosLineitemOptions(data.recadsOptions || [])
      }
      if (data.backfill_gam_code) {
        form1.setValue("backfill_gam_code", data.backfill_gam_code);
        form1.setValue("gamBackfill", `1`);
      }
      if(data.backfill_gam_src8_87){
        form1.setValue("backfill_gam_src8_87", `${data.backfill_gam_src8_87}`)
        form1.setValue("gamBackfill8_87", '1')
      }
    }
  }, [props.editData]);

  // useEffect(() => {
  //   if(!((watchBanner && selectedBannerSize === "300x250") || (selectedBannerSize1 === "300x250" && watchOtherAd))){
  //       form1.setValue('recads', [])
  //     }
  // },[watchBanner, watchOtherAd, selectedBannerSize1, selectedBannerSize])

  const getRecLineitemOptions = async () => {
    try {
      let res = await API({
        url: "/adunit/getRecLineitemOptions",
        method: "POST",
        responseType: "json",
        data: {
          lang_id: +props.target_filter.lang_id
        }
      })
      if(res.code === 200){
        setRecPosLineitemOptions(res.data)
      }
    } catch (error) {
      console.error("Error @ getRecLineitemOptions", error)
    }
  }

  // Function to handle type change for rec ads
  const handleRecAdTypeChange = (index, newType) => {
    const currentRecAds = [...watchRecAds];
    
    // Clear previous values when type changes
    if (newType?.value === 'panel') {
      currentRecAds[index] = {
        ...currentRecAds[index],
        type: newType,
        ad_code: '', // Clear ad_code when switching to panel
        campaign_id: null // Clear campaign_id when switching to panel
      };
    } else {
      currentRecAds[index] = {
        ...currentRecAds[index],
        type: newType,
        campaign_id: null // Clear campaign_id when switching away from panel
      };
    }
    
    form1.setValue("recads", currentRecAds);
    
    // Fetch lineitem options only when switching to panel type
    if (newType?.value === 'panel') {
      getRecLineitemOptions();
    }
  };

  // Fetch lineitem options on component mount if needed
  useEffect(() => {
    if (watchRecAds && watchRecAds.length > 0) {
      const hasPanelType = watchRecAds.some(item => item.type?.value === 'panel');
      if (hasPanelType && recPosWiseLineitemOptions.length === 0) {
        getRecLineitemOptions();
      }
    }
  }, []);

  const setfield = async (array, field) => {
    let arr = [];
    switch (field) {
      case "net_state_ids":
        let states = [];
        for await (let item of array) {
          const temp = { value: item, label: `${item.state_name}` };
          states.push(temp);
        }
        await state_idsOnchange(states, [props.target_filter.lang_id]);
        onchange(states, "net_state_ids");
        break;
      case "net_district_ids":
        let districts = [];
        for await (let item of array) {
          const temp = { value: item, label: `${item.dist_name}` };
          districts.push(temp);
        }
        onchange(districts, "net_district_ids");
        break;

      default:
    }
  };

  const getvalues = (Array, field) => {
    if (Array.length > 0) {
      switch (field) {
        case "net_state_ids":
          let fun = [];
          form1.getValues("net_state_ids").map((option) => {
            fun.push(option.state_id);
            return null;
          });
          return Array.filter(
            (option) => fun.indexOf(option.value.state_id) >= 0
          );
        case "net_district_ids":
          const res1 = [];
          form1.getValues("net_district_ids").map((option) => {
            res1.push(option.dist_id);
            return null;
          });
          return Array.filter(
            (option) => res1.indexOf(option.value.dist_id) >= 0
          );

        default:
          return [];
      }
    } else {
      return [];
    }
  };

  const fetchStates = async () => {
    try {
      let res = await API({
        url: "/location/getStatesByLangId",
        method: "POST",
        responseType: "json",
        data: [props.target_filter.lang_id],
      });
      let states = [];
      for await (let item of res.data) {
        const temp = { value: item, label: `${item.state_name}` };
        states.push(temp);
      }
      setStateOptions(states);
      form1.setValue(
        "net_state_ids",
        form1
          .getValues("net_state_ids")
          .filter(
            (option) =>
              [props.target_filter.lang_id].indexOf(option.lang_id) >= 0
          )
      );
    } catch (error) {
      console.error("Error @ fetchStates", error);
    }
  };

  useEffect(() => {
    fetchStates();
  }, []);

  const state_idsOnchange = async (selected, langs) => {
    const states = selected
      ? selected.map((item) => {
          if (item.value) return item.value.state_id;
        })
      : [];
    // const langs = formik.values.lang_ids
    try {
      let res = await API({
        url: "/location/getDistrictsByStateId",
        method: "POST",
        responseType: "json",
        data: { states, langs },
      });
      let districts = [];
      for await (let item of res.data) {
        const temp = { value: item, label: `${item.dist_name}` };
        districts.push(temp);
      }
      setDistrictOptions(districts);
      let temp = [];
      await form1.setValue(
        "net_district_ids",
        form1.getValues("net_district_ids").filter((option) => {
          if (states.indexOf(option.state_id) >= 0) {
            temp.push(option.dist_id);
            return true;
          }
        })
      );
    } catch (error) {
      console.error(error);
    }
  };

  const onchange = (selected, field) => {
    form1.setValue(field, selected ? selected.map((item) => item.value) : []);
  };
  return (
    <>
      <SlDrawer
        label="Add Position"
        open={props.show}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={() => {
          props.setShow(false);
          props.setPosition(false);
          props.setGam(false);
          props.setBackfill(false);
          props.setEditFlag(false);
        }}
        style={{ "--size": `${window.innerWidth <= 767 ? "100vw" : "60vw"}` }}
      >
        <div className="px-3 py-3 border border-dark">
          <form onSubmit={form1.handleSubmit(dummySubmit)}>
            <div className="mb-3">
              <label className="form-label">Position</label>
              <Controller
                name="position" // Name of the form field
                control={form1.control}
                rules={{ required: !(props.position === 0 || props.position) }}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="position_"
                    placeholder={
                      props.position || props.position === 0
                        ? props.position
                        : "Select Position"
                    }
                    isDisabled={
                      props.position || props.position === 0 ? true : false
                    }
                    options={POSITION_OPTIONS}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                )}
              />
              {form1.formState.errors?.position ? (
                <p className="red-text">Poistion is required!</p>
              ) : null}
              <label className="form-label">Type</label>
              <Controller
                name="type" // Name of the form field
                control={form1.control}
                rules={{ required: !props.gam }}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="type_"
                    isDisabled={props.gam}
                    options={filteredTypeOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                )}
              />
              {form1.formState.errors?.type ? (
                <p className="red-text">Type is required!</p>
              ) : null}
              {watchType && (
                <div>
                  {watchType?.value !== "panel" && (
                    <>
                      <label className="form-label">Sub Type</label>
                      <Controller
                        name="subType" // Name of the form field
                        control={form1.control}
                        rules={{ required: watchType?.value !== "panel" }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            name="subType_"
                            options={SUBTYPE_OPTIONS}
                            className="basic-multi-select"
                            classNamePrefix="select"
                          />
                        )}
                      />
                      {form1.formState.errors?.subType ? (
                        <p className="red-text">SubType is required!</p>
                      ) : null}
                    </>
                  )}
                  {watchType?.value !== "panel" && (
                    <>
                      <label className="form-label">Source</label>
                      <Controller
                        name="adType" // Name of the form field
                        control={form1.control}
                        rules={{ required: watchType?.value !== "panel" }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            name="adType_"
                            options={SOURCE_OPTIONS}
                            className="basic-multi-select"
                            classNamePrefix="select"
                          />
                        )}
                      />
                      {form1.formState.errors?.adType ? (
                        <p className="red-text">Source is required!</p>
                      ) : null}
                    </>
                  )}
                    {(props.backfill) ? null : (
                        <div className="mb-3">
                          <label className="form-label">Slot</label>
                          <br />
                          {
                          SLOT_OPTIONS.map((slot) => (
                            (slot.value === '3' && watchType?.value === 'panel') ? null :
                            <div class="form-check form-check-inline">
                            <input
                              disabled={watchType && watchType?.value === 'panel' ? !enabledPositionSlots.includes(+slot.value) : false}
                              className={`form-check-input ${watchType && watchType?.value === 'panel' ? !enabledPositionSlots.includes(+slot.value) ? 'disabled' : '' : ''}`}
                              type="radio"
                              name="slotoptions"
                              title={watchType && watchType?.value === 'panel' ? !enabledPositionSlots.includes(+slot.value) ? 'Slot is not enabled for this position' : '' : ''}
                              id={slot.label}
                              {...form1.register("slot", { required: true})}
                              value={slot.value}
                            />
                            <label class="form-check-label" for={slot.label}>
                              {slot.label}
                            </label>
                          </div>
                          ))}
                          {form1.formState.errors?.slot ? (
                            <p className="red-text">Slot is required!</p>
                          ) : null}
                        </div>
                      )}
                  {watchType?.value === "panel" ? (
                    <>
                    
                      <label className="form-label">LineItem</label>
                      <Controller
                        name="adName" // Name of the form field
                        control={form1.control}
                        rules={{ required: true }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            name="adName_"
                            options={positionData}
                            className="basic-multi-select"
                            classNamePrefix="select"
                          />
                        )}
                      />
                      {form1.formState.errors?.adName ? (
                        <p className="red-text">LineItem is required!</p>
                      ) : null}
                    </>
                  ) : (
                    watchAdType?.value !== "magicbid" && (
                      <>
                        <div className="my-1">
                          <label className="form-label">Ad Type</label>
                          <Select
                            name="adType_"
                            value={
                              watchAdType?.value === "google"
                                ? {
                                    label: "Native Advanced",
                                    value: "Native Advanced",
                                  }
                                : {
                                    label: "Native",
                                    value: "Native",
                                  }
                            }
                            options={
                              watchAdType?.value === "google"
                                ? ADTYPE_OPTIONS.slice(1)
                                : ADTYPE_OPTIONS.slice(0, 1)
                            }
                            className="basic-multi-select"
                            classNamePrefix="select"
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Design Type</label>
                          <Controller
                            name="designType" // Name of the form field
                            control={form1.control}
                            rules={{ required: true }}
                            render={({ field }) => (
                              <Select
                                {...field}
                                name="designType"
                                options={DESIGN_OPTIONS}
                                className="basic-multi-select"
                                classNamePrefix="select"
                              />
                            )}
                          />
                          {form1.formState.errors?.designType ? (
                            <p className="red-text">Design type is required!</p>
                          ) : null}
                        </div>
                        {
                          watchDesignType?.value === 5 ?   <>
                          <label className="form-label w-100">
                            {" "}
                            Choose Format
                          </label>
                          {DESIGN_FORMAT_OPTIONS.map((dFormat)=>(
                              <div className="form-check form-check-inline">
                              <label
                                className="form-check-label"
                                htmlFor={dFormat.label}
                              >
                                {dFormat.label}
                              </label>
                              <input
                                className="form-check-input"
                                type="radio"
                                id={dFormat.label}
                                value={dFormat.value}
                                {...form1.register("full_scr_type", {
                                  required: true,
                                })}
                               
                              />
                            </div>
                          ))}
                          {form1.formState.errors.full_scr_type && (
                            <p className="text-red-600">
                              Please select Design Format
                            </p>
                          )}
                        </> : null
                        }
                        <div className="mb-1">
                          <label className="form-label">Ad Name</label>
                          <input
                            className="form-control h-9" placeholder="Enter Ad Name.."
                            {...form1.register("adName", { required: true })}
                          ></input>
                          {form1.formState.errors?.adName ? (
                            <p className="red-text">Ad Name is required!</p>
                          ) : null}
                        </div>
                        <div className="flex gap-3 my-3 flex-wrap mb-3">
                          <div className="flex flex-col">
                          <label className="form-label">Native Ad Code</label>
                          <input
                            className="form-control h-9" placeholder="Enter Native Ad Code"
                            {...form1.register("adCode", { required: true, onChange: () => form1.trigger("adCode_partner") })}
                          ></input>
                          {form1.formState.errors?.adCode ? (
                            <p className="red-text">Ad Code is required!</p>
                          ) : null}
                          </div>
                          <div >
                            <label className="form-label">Ad Partner</label>
                            <Controller
                              name="adCode_partner"
                              control={form1.control}
                              rules={{
                                validate: (value) => {
                                  if (watchAdCode && String(watchAdCode).trim() !== "") {
                                    return value && value.value ? true : "Partner required when ad code is filled";
                                  }
                                  return true;
                                },
                              }}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  name="adCode_partner"
                                  options={adPartners}
                                  classNamePrefix="select"
                                  placeholder="Select Partner"
                                  onChange={(opt) => {
                                    field.onChange(opt);
                                    form1.trigger("adCode_partner");
                                  }}
                                />
                              )}
                            />
                            {form1.formState.errors?.adCode_partner && (
                              <p className="red-text">{form1.formState.errors.adCode_partner.message}</p>
                            )}
                          </div>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="banner_ad_8.49"
                            {...form1.register("bannerAd", {
                              required: false,
                            })}
                          />
                          <label className="text-xl font-bold" htmlFor="banner_ad_8.49">Banner Ad (From 8.49 version)</label>
                          <hr></hr>
                        </div>
                        {watchBanner && (
                          <div>
                            <h6>
                              Banner Ad (Optional, 300X600 / 300X250 / 320X480 / 640X480 / 1080X1776)
                            </h6>
                            <div className="d-flex gap-3 flex-wrap">
                              <div className="flex gap-3">
                                <Select
                                  onChange={(e) => {
                                    form1.setValue("banner_src", e.value);
                                    setBannerSource({
                                      label: e.label,
                                      value: e.value,
                                    });
                                  }}
                                  defaultValue={bannerSource}
                                  options={[
                                    { label: "Google", value: "google" },
                                    { label: "Facebook", value: "fb" },
                                  ]}
                                ></Select>
                              </div>
                                <div className="flex gap-3 mb-3">
                                  <div>
                                    <input
                                    className="form-control h-9 "
                                    {...form1.register("banner_code", {
                                      required: true,
                                      onChange: () => form1.trigger("banner_code_partner")
                                    })}
                                    placeholder="Ad Code"
                                  ></input>
                                  </div>
                                  <div className="w-72">
                                    <Controller
                                      name="banner_code_partner"
                                      control={form1.control}
                                      rules={{
                                        validate: (value) => {
                                          if (watchBannerCode && String(watchBannerCode).trim() !== "") {
                                            return value && value.value ? true : "Partner required when banner code is filled";
                                          }
                                          return true;
                                        },
                                      }}
                                      render={({ field }) => (
                                        <Select
                                          {...field}
                                          name="banner_code_partner"
                                          options={adPartners}
                                          classNamePrefix="select"
                                          placeholder="Select Partner"
                                          onChange={(opt) => {
                                            field.onChange(opt);
                                            form1.trigger("banner_code_partner");
                                          }}
                                        />
                                      )}
                                    />
                                  </div>
                                  {form1.formState.errors?.banner_code ? (
                                    <p className="red-text w-full">
                                      Banner Code is required!
                                    </p>
                                  ) : null}
                                  {form1.formState.errors?.banner_code_partner && (
                                    <p className="red-text w-full">
                                      {form1.formState.errors.banner_code_partner.message}
                                    </p>
                                  )}
                                </div>
                              <div className="d-flex gap-3 flex-wrap">
        <label className="form-label w-100">Choose banner size</label>
        {BANNER_SIZE_OPTIONS.map((size) => (
          <div className="form-check" key={size.value}>
            <label className="form-check-label" htmlFor={`${size.label}_check`}>
              {size.label}
            </label>
            <input
              className="form-check-input"
              type="checkbox"
              id={`${size.label}_check`}
              value={size.value}
              {...form1.register("checkbox", {
                required: "Please select at least one banner size",
                validate: (value) => {
                  return (Array.isArray(value) && value.length > 0) || 
                         "Please select at least one banner size";
                }
              })}

            />
          </div>
        ))}
        {form1.formState.errors?.checkbox && (
          <p className="text-red-600 w-100">
            {form1.formState.errors.checkbox.message}
          </p>
        )}
      </div>
                            </div>
                          </div>
                        )}

                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="other_source_ad_8.50"
                            {...form1.register("otherAd", {
                              required: false,
                            })}
                          />
                          <label className="text-xl font-bold" htmlFor="other_source_ad_8.50">Other Source Ad (From 8.50 version)</label>
                          <hr></hr>
                        </div>

                        {watchOtherAd && (
                          <>
                            <div className="d-flex justify-content-around align-items-center">
                              {OTHER_AD_TYPES.map((otherAdType)=>(
                                <div className="form-check">
                                <label
                                  className="form-check-label"
                                  htmlFor={otherAdType.label}
                                >
                                  {otherAdType.label}
                                </label>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  id={otherAdType.label}
                                  {...form1.register("otherAdType", {
                                    required: {
                                      value: true,
                                      message: "this is required",
                                    },
                                    onChange: () =>
                                      form1.setValue("otherAdSrc", ""),
                                  })}
                                  value={otherAdType.value}
                                />
                              </div>
                              ))}
                              
                            </div>
                            {form1.formState.errors?.otherAdType ? (
                              <p className="red-text">Source is required!</p>
                            ) : null}
                            <label className="form-label">
                              Select Ad Source
                            </label>
                            <Controller
                              name="otherAdSrc" // Name of the form field
                              control={form1.control}
                              rules={{
                                required: {
                                  value: true,
                                  message: "this is required",
                                },
                              }}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  name="otherAdSrc_1"
                                  options={
                                    selectedOtherAdType === "1"
                                      ? NativeAdsOptions
                                      : // : selectedOtherAdType === "2"
                                      // ? InterstitialAd
                                      selectedOtherAdType === "3"
                                      ? otherAdSrcs
                                      : NativeBanner
                                  }
                                  classNamePrefix="select"
                                />
                              )}
                            />
                            {form1.formState.errors?.otherAdSrc ? (
                              <p className="red-text">Source is required!</p>
                            ) : null}
                            {selectedOtherAdType === "1" &&
                              selectedOtherAdSrc?.value === "vdo" && (
                                <div className="flex gap-3 my-3 flex-wrap">
                                 <div className="flex flex-col">
                                    <label className="form-label mt-2">
                                      Ad Code
                                    </label>
                                    <input
                                      className="form-control"
                                      placeholder="Enter Ad Code"
                                      {...form1.register("other_ad_code", {
                                        required: true,
                                      })}
                                    ></input>
                                    {form1.formState.errors.other_ad_code && (
                                    <p className="text-red-600">
                                      Ad code is required!
                                    </p>
                                  )}
                                  </div>
                                   <div>
                                    <label className="form-label">Ad Partner</label>
                                    <Controller
                                      name="other_ad_code_partner"
                                      control={form1.control}
                                      rules={{
                                        validate: (value) => {
                                          if (watchOtherAdCode && String(watchOtherAdCode).trim() !== "") {
                                            return value && value.value ? true : "Partner required when ad code is filled";
                                          }
                                          return true;
                                        },
                                      }}
                                      render={({ field }) => (
                                        <Select
                                          {...field}
                                          name="other_ad_code_partner"
                                          options={adPartners}
                                          classNamePrefix="select"
                                          placeholder="Select Partner"
                                          onChange={(opt) => {
                                            field.onChange(opt);
                                            form1.trigger("other_ad_code_partner");
                                          }}
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                              )}
                            {(selectedOtherAdType === "3" || selectedOtherAdType === "4") ? (
                              <>
                             <div className="d-flex gap-4">
                                    {BANNER_SIZE_OPTIONS.map((size) => (
                                      <div className="form-check" key={size.value}>
                                        <label className="form-check-label" htmlFor={`${size.label}_check1`}>
                                          {size.label}
                                        </label>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          value={size.value}
                                          id={`${size.label}_check1`}
                                          {...form1.register("checkbox1", { required: true })}
                                         
                                        />
                                      </div>
                                    ))}
                                  </div>
                                  {form1.formState.errors.checkbox1 && (
                                    <p className="text-red-600">Please select at least one banner size</p>
                                  )}
                              </>
                            ) : null}
                            <div className="d-flex justify-between gap-5">
                              {selectedOtherAdType === "3" &&
                              ['vdo', 'gm_nmb','gm_amz_nmb1','gm_amz_nmb','gm_amz'].includes(selectedOtherAdSrc?.value)
                                 && (
                                  <div className="flex gap-3 w-2/3 mt-3 flex-wrap">
                                  <div className="w-1/2">
                                    <label>Ad code</label>
                                    <input
                                      className="form-control"
                                      placeholder="Enter Ad code"
                                      {...form1.register("other_ad_code", {
                                        required: true,
                                        onChange: () => form1.trigger("other_ad_code_partner")
                                      })}
                                    ></input>
                                    <br/>
                                    {form1.formState.errors.other_ad_code && (
                                      <p className="text-red-600">
                                        Please enter Adcode
                                      </p>
                                    )}
                                    </div>
                                    <div>
                                      <label className="form-label mb-0">Ad Partner</label>
                                      <Controller
                                        name="other_ad_code_partner"
                                        control={form1.control}
                                        rules={{
                                          validate: (value) => {
                                            if (watchOtherAdCode && String(watchOtherAdCode).trim() !== "") {
                                              return value && value.value ? true : "Partner required when ad code is filled";
                                            }
                                            return true;
                                          },
                                        }}
                                        render={({ field }) => (
                                          <Select
                                            {...field}
                                            name="other_ad_code_partner"
                                            options={adPartners}
                                            classNamePrefix="select"
                                            placeholder="Select Partner"
                                            onChange={(opt) => {
                                              field.onChange(opt);
                                              form1.trigger("other_ad_code_partner");
                                            }}
                                          />
                                        )}
                                      />
                                    </div>
                                  </div>
                                )}
                              {selectedOtherAdType === "3" &&
                              ['gm_amz_nmb','gm_amz_nmb1','gm_amz'].includes(selectedOtherAdSrc?.value)
                                 && (
                                  <div className="flex gap-3 w-1/3 my-3 flex-wrap">
                                    <div className="mb-3 w-full">
                                      <label>Amazon slot uuid</label>
                                      <input
                                        className="form-control"
                                        placeholder="Enter Amazon Slot vvid"
                                        {...form1.register("other_slotuuid", {
                                          required: true,
                                        })}
                                      ></input>
                                      {form1.formState.errors.other_slotuuid && (
                                        <p className="text-red-600">
                                          Amazon slot uuid is required!
                                        </p>
                                      )}
                                    </div>
                                    </div>
                                )}
                            </div>
                            {selectedOtherAdType === "4" && (
                              <div className="flex gap-3 mt-3 flex-wrap ">
                              <div className="flex flex-col">
                                <label className="form-label mt-2">
                                  Ad Code
                                </label>
                                <input
                                  className="form-control"
                                  placeholder="Enter Ad Code"
                                  {...form1.register("other_ad_code", {
                                    required: true,
                                    onChange: () => form1.trigger("other_ad_code_partner")
                                  })}
                                ></input>
                                <br /> 
                                {form1.formState.errors.other_ad_code && (
                                  <p className="text-red-600">
                                    Ad code is required!
                                  </p>
                                )}
                                </div>
                                <div className=" mt-2">
                                  <label className="form-label">Ad Partner</label>
                                  <Controller
                                    name="other_ad_code_partner"
                                    control={form1.control}
                                      rules={{
                                        validate: (value) => {
                                          if (watchOtherAdCode && String(watchOtherAdCode).trim() !== "") {
                                            return value && value.value ? true : "Partner required when ad code is filled";
                                          }
                                          return true;
                                        },
                                      }}
                                    render={({ field }) => (
                                      <Select
                                        {...field}
                                        name="other_ad_code_partner"
                                        options={adPartners}
                                        classNamePrefix="select"
                                        placeholder="Select Partner"
                                          onChange={(opt) => {
                                            field.onChange(opt);
                                            form1.trigger("other_ad_code_partner");
                                          }}
                                      />
                                    )}
                                  />
                              </div>
                               
                              {(  selectedOtherAdSrc?.value === "gm_amz") && (
                                <div className="">
                                  <label className="form-label mt-2" htmlFor="amzn_slot_uuid">Amazon slot uuid</label>
                                  <input
                                    className="form-control"
                                    id="amzn_slot_uuid"
                                    placeholder="Enter Amazon Slot vvid"
                                    {...form1.register("other_slotuuid", {
                                      required: true,
                                    })}
                                  ></input>
                                  <br/>
                                  {form1.formState.errors.other_slotuuid && (
                                    <p className="text-red-600">
                                      Amazon slot uuid is required!
                                    </p>
                                  )}
                                </div>
                              )}
                              </div>
                            )}
                            {
                              (selectedOtherAdType === '3' || selectedOtherAdType === '4') && (selectedOtherAdSrc?.value ===  'gm_amz' || selectedOtherAdSrc?.value === 'google') &&
                              <>
                              <label className="form-label w-full">
                                {" "}
                                Prebid
                              </label>
                              {PREBID_OPTIONS.map((prebidOps)=>(
                                 <div className="form-check form-check-inline">
                                  <label
                                    className="form-check-label"
                                    htmlFor={prebidOps.label}
                                  >
                                   {prebidOps.label}
                                  </label>
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    value={prebidOps.value}
                                    id={prebidOps.label}
                                    {...form1.register("prebid", {
                                      required: true,
                                    })}
                                   
                                  />
                                </div>
                              ))}
                             <br/>
                              {form1.formState.errors.prebid && (
                                <p className="text-red-600">
                                  Please select Prebid
                                </p>
                              )}
                            </>
                            }
                          </>
                        )}
                        {}
                        {/* placement and display type */}
                        {(watchBanner || watchOtherAd) && (
                          <>
                            {!onlyFullScreenBanner && (
                            <div className="my-3">
                              <h6>Position</h6>
                              {POSITION_OPTIONS_RADIO.map((postOption)=>(
                                <div className="form-check form-check-inline">
                                  <label
                                    className="form-check-label"
                                    htmlFor={postOption.label}
                                  >
                                    {postOption.label}
                                  </label>
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    id={postOption.label}
                                    value={postOption.value}
                                    {...form1.register("placement", {
                                      required: true,
                                    })}
                                  />
                                </div>
                              ))}
                              {form1.formState.errors.placement && (
                                <p className="text-red-600">
                                  Position is required!
                                </p>
                              )}
                            </div>
                            )}
                            {/* <div className="my-3">
                              <h6>Margin</h6>
                              <div className="d-flex gap-3">
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="top_mar"
                                  >
                                    Margin Top
                                  </label>
                                  <input
                                    id="top_mar"
                                    className="form-control"
                                    type="number"
                                    {...form1.register("top_mar", {
                                      required: false,
                                      min: {
                                        value: 1,
                                        message:
                                          "Margin Top must be at least 1",
                                      },
                                      max: {
                                        value: 100,
                                        message:
                                          "Margin Top cannot be more than 100",
                                      },
                                    })}
                                  />
                                  {form1.formState.errors?.top_mar && (
                                    <p className="text-red-600">
                                      {form1.formState.errors?.top_mar.message}
                                    </p>
                                  )}
                                </div>

                                <div className="mb-3">
                                        <label className="form-label" htmlFor="btm_mar">
                                          Margin Bottom
                                        </label>
                                        <input
                                          id="btm_mar"
                                          className="form-control"
                                          type="number"
                                          {...form1.register("btm_mar", {
                                            required: false,
                                            min: {
                                              value: 0,
                                              message: "Margin Bottom must be at least 0",
                                            },
                                            max: {
                                              value: 100,
                                              message: "Margin Bottom cannot be more than 100",
                                            },
                                          })}
                                        />
                                        {form1.formState.errors?.btm_mar && (
                                          <p className="text-red-600">{form1.formState.errors?.btm_mar.message}</p>
                                        )}
                                      </div>
                              </div>
                            </div> */}

                            {((selectedBannerSize1?.length >= 1 && selectedBannerSize1.includes("300x250") ||
                              (selectedBannerSize?.length >= 1 && selectedBannerSize.includes("300x250")))) && (
                              <div className="my-3">
                                <h6>Design Type</h6>
                                {DESIGN_TYPE_OPTIONS.map((designTypeOps=>(
                                  <div className="form-check form-check-inline">
                                    <label
                                      className="form-check-label"
                                      htmlFor={designTypeOps.label}
                                    >
                                      {designTypeOps.label}
                                    </label>
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      id={designTypeOps.label}
                                      {...form1.register("news_display", {
                                        required: true,
                                      })}
                                      value={designTypeOps.value}
                                    />
                                  </div>
                                )))    
                                }
                                {form1.formState.errors.news_display && (
                                  <p className="text-red-600">
                                    Design Type is required!
                                  </p>
                                )}
                              </div>
                            )}
                          </>
                        )}
                        {(watchBanner && (selectedBannerSize?.length === 1 && selectedBannerSize[0] === "300x250")) ||
                        (  watchOtherAd && (selectedBannerSize1?.length === 1 && selectedBannerSize1[0] === "300x250")) ? (
                          <div className="mb-3 d-flex justify-center gap-1 flex-col items-start">
                            <h5>Recommended Ads</h5>
                            <div className={`d-flex flex-col gap-1 w-full`}>
                              {watchRecAds.map((item, index) => (
                                <div
                                  key={index}
                                  className="d-flex w-full justify-between gap-4 items-start"
                                >
                                  {/* Type Field */}
                                  <div className="flex flex-col gap-3 my-3 flex-wrap">
                                    <div className="flex gap-3">
                                      <div>
                                        <label className="form-label">Type</label>
                                        <Controller
                                          name={`recads.${index}.type`} // Bind to specific array item
                                          control={form1.control}
                                          rules={{
                                            required: "Type is required",
                                          }}
                                          render={({ field }) => (
                                            <Select
                                              {...field}
                                              options={RECADTYPE_OPTIONS}
                                              className="basic-multi-select"
                                              classNamePrefix="select"
                                              value={item.type}
                                              onChange={(newType) => {
                                                field.onChange(newType);
                                                handleRecAdTypeChange(index, newType);
                                              }}
                                            />
                                          )}
                                        />
                                        {form1.formState?.errors?.recads?.[index]
                                          ?.type && (
                                          <p className="red-text">
                                            {
                                              form1.formState.errors.recads[index]
                                                .type.message
                                            }
                                          </p>
                                        )}
                                        </div>
                                    <div>
                                      <label className="form-label">
                                        Position
                                      </label>
                                      <Controller
                                        name={`recads.${index}.rec_position`} // Bind to specific array item
                                        control={form1.control}
                                        rules={{
                                          required: "Position is required",
                                          validate: (value) => {
                                            if (!value?.value) {
                                              return "Select Position";
                                            }
                                            return true;
                                          },
                                        }}
                                        render={({ field }) => (
                                          <Select
                                            {...field}
                                            options={[
                                              { label: "Select", value: "" },
                                              ...RECADPOSITION_OPTIONS
                                            ]}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            value={item.rec_position}
                                          />
                                        )}
                                      />
                                      {form1.formState?.errors?.recads?.[index]
                                        ?.rec_position && (
                                        <p className="red-text">
                                          {
                                            form1.formState.errors.recads[index]
                                              .rec_position.message
                                          }
                                        </p>
                                      )}
                                    </div>
                                    </div>
                                    {item.type?.value !== 'panel' ? 
                                    <div className="flex gap-3 my-3 flex-wrap">
                                      <div className="flex flex-col ">
                                        <label className="form-label">
                                          Ad Code
                                        </label>
                                        <input
                                          className="form-control h-9"
                                          {...form1.register(
                                            `recads.${index}.ad_code`,
                                            {
                                              required: "Ad Code is required",
                                              onChange: () => form1.trigger(`recads.${index}.ad_code_partner`)
                                            }
                                          )}
                                        />
                                        {form1.formState?.errors?.recads?.[index]
                                        ?.ad_code && (
                                        <p className="red-text">
                                          {
                                            form1.formState.errors.recads[index]
                                              .ad_code.message
                                          }
                                        </p>
                                      )}
                                      </div>
                                      <div className="w-72">
                                        <label className="form-label">Ad Partner</label>
                                        <Controller
                                          name={`recads.${index}.ad_code_partner`}
                                          control={form1.control}
                                          rules={{
                                            validate: (value) => {
                                              const current = (form1.getValues("recads") || [])[index];
                                              const isPanel = current?.type?.value === "panel";
                                              const hasCode = current?.ad_code && String(current.ad_code).trim() !== "";
                                              if (!isPanel && hasCode) {
                                                return value && value.value ? true : "Partner required when ad code is filled";
                                              }
                                              return true;
                                            },
                                          }}
                                          render={({ field }) => (
                                            <Select
                                              {...field}
                                              options={adPartners}
                                              classNamePrefix="select"
                                              placeholder="Select Partner"
                                              onChange={(opt) => {
                                                field.onChange(opt);
                                                form1.trigger(`recads.${index}.ad_code_partner`);
                                              }}
                                            />
                                          )}
                                        />
                                        {form1.formState?.errors?.recads?.[index]?.ad_code_partner && (
                                          <p className="red-text">
                                            {form1.formState.errors.recads[index].ad_code_partner.message}
                                          </p>
                                        )}
                                    </div>
                                    </div> 
                                  : 
                                    <div className="d-flex flex-col justify-start w-full">
                                    <label className="form-label">Lineitem</label>{console.log(item)}
                                    <Controller
                                      name={`recads.${index}.campaign_id`} // Bind to specific array item
                                      control={form1.control}
                                      rules={{
                                        required: "Lineitem is required",
                                      }}
                                      render={({ field }) => {
                                        // Get all currently selected campaign IDs from other rec ads
                                        const selectedCampaignIds = watchRecAds
                                          .map((recAd, recIndex) => 
                                            recIndex !== index && recAd.campaign_id?.value 
                                              ? recAd.campaign_id.value 
                                              : null
                                          )
                                          .filter(id => id !== null);

                                        // Filter out already selected campaigns from options
                                        const availableOptions = recPosWiseLineitemOptions.filter(
                                          option => !selectedCampaignIds.includes(option.value)
                                        );

                                        return (
                                          <Select
                                            {...field}
                                            options={availableOptions}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            value={item.campaign_id}
                                            isDisabled={availableOptions.length === 0}
                                            placeholder={availableOptions.length === 0 ? "No available campaigns" : "Select Lineitem"}
                                          />
                                        );
                                      }}
                                    />
                                    {form1.formState?.errors?.recads?.[index]
                                      ?.campaign_id && (
                                      <p className="red-text">
                                        {
                                          form1.formState.errors.recads[index]
                                            .campaign_id.message
                                        }
                                      </p>
                                    )}
                                  </div>
                                  }
                                  </div>
                                  {/* Ad Code Field */}
                                    
                                  <div className="col3 text-danger my-auto">
                                    <sl-icon
                                      library="lucide"
                                      name="x-circle"
                                      type="button"
                                      size="medium"
                                      aria-hidden="true"
                                      onClick={() => {
                                        const newDateRanges = [...watchRecAds];
                                        newDateRanges.splice(index, 1); // Remove the selected date range
                                        form1.setValue("recads", newDateRanges);
                                      }}
                                    ></sl-icon>
                                  </div>
                                </div>
                              ))}
                            </div>
                              <button
                                type="button"
                                className="btn"
                                onClick={() =>
                                  form1.setValue("recads", [
                                    ...watchRecAds,
                                    { type: "", ad_code: "", rec_position: "", campaign_id: null },
                                  ])
                                }
                              >
                                <i className="bi bi-plus-circle-fill text-primary fs-2"></i>
                              </button>
                          </div>
                        ) : null}
                         <div className="form-check">
                          <input
                            className="form-check-input"
                            id="other_source_ad_8.88"
                            type="checkbox"
                            {...form1.register("otherAd8_87", {
                              required: false,
                            })}
                          />
                          <label className="text-xl font-bold" htmlFor="other_source_ad_8.88">Other Source Ad (From 8.88 version)</label>
                          <hr></hr>
                        </div>
                        {watchOtherAd8_87 && (
                          <>
                            <div className="d-flex justify-content-around align-items-center">
                              <div className="form-check">
                                <label
                                  className="form-check-label"
                                  htmlFor="native_ad_8_87"
                                >
                                  Native Ad
                                </label>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  id="native_ad_8_87"
                                  {...form1.register("otherAdType8_87", {
                                    required: {
                                      value: true,
                                      message: "this is required",
                                    },
                                    onChange: () =>
                                      form1.setValue("otherAdSrc8_87", {label:"Applovin", value:"applovin"}),
                                  })}
                                  value="1"
                                />
                              </div>
                             
                              <div className="form-check">
                                <label
                                  className="form-check-label"
                                  htmlFor="banner_ad_8_87"
                                >
                                  Banner Ad
                                </label>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  value="3"
                                  id="banner_ad_8_87"
                                  {...form1.register("otherAdType8_87", {
                                    required: {
                                      value: true,
                                      message: "this is required",
                                    },
                                    onChange: () =>
                                      form1.setValue("otherAdSrc8_87", {label:"Applovin", value:"applovin"}),
                                  })}
                                />
                              </div>
                             
                            </div>
                            {form1.formState.errors?.otherAdType8_87 ? (
                              <p className="red-text">Source is required!</p>
                            ) : null}
                            <label className="form-label">
                              Select Ad Source
                            </label>
                            <Controller
                              name="otherAdSrc8_87" // Name of the form field
                              control={form1.control}
                              rules={{
                                required: {
                                  value: true,
                                  message: "this is required",
                                },
                              }}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  name="otherAdSrc_18_87"
                                  options={
                                    getSoruces()
                                  }
                                  classNamePrefix="select"
                                />
                              )}
                            />
                            {form1.formState.errors?.otherAdSrc8_87 ? (
                              <p className="red-text">Source is required!</p>
                            ) : null}
                           
                            {selectedOtherAdType8_87 === "3" && (
                                <>
                                  <label className="form-label">Choose banner size</label>
                                  <div className="d-flex gap-4 flex-wrap">
                                    {BANNER_SIZE_OPTIONS.map((size) => (
                                      <div className="form-check" key={size.value}>
                                        <label className="form-check-label" htmlFor={`${size.label}_check18_87`}>
                                          {size.label}
                                        </label>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id={`${size.label}_check18_87`}
                                          value={size.value}
                                          {...form1.register("checkbox18_87", {
                                            required: "Please select at least one banner size",
                                            validate: (value) => {
                                              return (Array.isArray(value) && value.length > 0) || 
                                                      "Please select at least one banner size";
                                            }
                                          })}
                                        />
                                      </div>
                                    ))}
                                    {form1.formState.errors?.checkbox18_87 && (
                                      <p className="text-red-600 w-100">
                                        {form1.formState.errors.checkbox18_87.message}
                                      </p>
                                    )}
                                  </div>
                                </>
                                )}
                            <div className="d-flex justify-between gap-5">
                              {selectedOtherAdType8_87 === "3" &&
                                
                                 <div className="flex gap-3 my-3">
                                  <div className="flex flex-col  mt-2">
                                    <label>Ad code</label>
                                    <input
                                      className="form-control"
                                      placeholder="Enter Ad code"
                                      {...form1.register("other_ad_code8_87", {
                                        required: true,
                                        onChange: () => form1.trigger("other_ad_code8_87_partner")
                                      })}
                                    ></input>
                                    <br/>
                                    {form1.formState.errors.other_ad_code8_87 && (
                                      <p className="text-red-600">
                                        Please enter Adcode
                                      </p>
                                    )}
                                  </div>
                                  <div>
                                  <div className="w-72">
                                    <label className="form-label">Ad Partner</label>
                                    <Controller
                                      name="other_ad_code8_87_partner"
                                      control={form1.control}
                                      rules={{
                                        validate: (value) => {
                                          if (watchOtherAdCode8_87 && String(watchOtherAdCode8_87).trim() !== "") {
                                            return value && value.value ? true : "Partner required when ad code is filled";
                                          }
                                          return true;
                                        },
                                      }}
                                      render={({ field }) => (
                                        <Select
                                          {...field}
                                          name="other_ad_code8_87_partner"
                                          options={adPartners}
                                          classNamePrefix="select"
                                          placeholder="Select Partner"
                                          onChange={(opt) => {
                                            field.onChange(opt);
                                            form1.trigger("other_ad_code8_87_partner");
                                          }}
                                        />
                                      )}
                                    />
                                  </div>
                                  </div>
                                  </div>
                                }
                              {selectedOtherAdType8_87 === "3" &&
                                (
                                  selectedOtherAdSrc8_87?.value === "applovin_amz") && (
                                  <div className="mb-3 w-1/2">
                                    <label>Amazon slot uuid</label>
                                    <input
                                      className="form-control"
                                      placeholder="Enter Amazon Slot uuid"
                                      {...form1.register("other_slotuuid8_87", {
                                        required: true,
                                      })}
                                    ></input>
                                    {form1.formState.errors.other_slotuuid && (
                                      <p className="text-red-600">
                                        Amazon slot uuid is required!
                                      </p>
                                    )}
                                  </div>
                                )}
                            </div>
                            {selectedOtherAdType8_87 === '1' && (
                              <div className="flex gap-3 my-3 flex-wrap">
                                <div className="flex flex-col">
                                  <label className="form-label mt-2">
                                    Ad Code
                                  </label>
                                  <input
                                    className="form-control"
                                    placeholder="Enter Ad Code"
                                    {...form1.register("other_ad_code8_87", {
                                      required: true,
                                      onChange: () => form1.trigger("other_ad_code8_87_partner")
                                    })}
                                  ></input>
                                  {form1.formState.errors.other_ad_code8_87 && (
                                    <p className="text-red-600">
                                      Ad code is required!
                                    </p>
                                  )}
                                </div>
                                <div className="mt-2">
                                  <label className="form-label">Ad Partner</label>
                                  <Controller
                                    name="other_ad_code8_87_partner"
                                    control={form1.control}
                                    rules={{
                                      validate: (value) => {
                                        if (watchOtherAdCode8_87 && String(watchOtherAdCode8_87).trim() !== "") {
                                          return value && value.value ? true : "Partner required when ad code is filled";
                                        }
                                        return true;
                                      },
                                    }}
                                    render={({ field }) => (
                                      <Select
                                        {...field}
                                        name="other_ad_code8_87_partner"
                                        options={adPartners}
                                        classNamePrefix="select"
                                        placeholder="Select Partner"
                                        onChange={(opt) => {
                                          field.onChange(opt);
                                          form1.trigger("other_ad_code8_87_partner");
                                        }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )
                  )}
                  {watchType?.value !== "panel" ? (
                    <>
                      <div className="mb-3">
                        <label htmlFor="" className="form-label">
                          States
                        </label>
                        <Controller
                          name="net_state_ids" // Name of the form field
                          control={form1.control}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              aria-label="Default select example"
                              name="states_ids"
                              placeholder="Select States"
                              value={getvalues(stateOptions, "net_state_ids")}
                              onChange={(selected) => {
                                onchange(selected, "net_state_ids");
                                state_idsOnchange(selected, [
                                  props.target_filter.lang_id,
                                ]);
                              }}
                              options={stateOptions}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              isMulti
                            />
                          )}
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="" className="form-label">
                          Districts
                        </label>
                        <Controller
                          name="net_district_ids" // Name of the form field
                          control={form1.control}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              aria-label="Default select example"
                              name="net_district_ids"
                              placeholder="Select Districts"
                              value={getvalues(
                                districtOptions,
                                "net_district_ids"
                              )}
                              onChange={(selected) => {
                                onchange(selected, "net_district_ids");
                              }}
                              options={districtOptions}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              isMulti
                            />
                          )}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Operating System</label>
                        <br></br>
                        {OPERATING_SYSTEMS.map((opsSysttem)=> (
                           <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            {...form1.register("os", { required: false })}
                            defaultChecked={opsSysttem.value === '0'}
                            id={opsSysttem.label}
                            value={opsSysttem.value}
                          />
                          <label class="form-check-label" for={opsSysttem.label}>
                            {opsSysttem.label}
                          </label>
                        </div>
                        ))}
                      </div>
                       <div>
                        <div className="form-check">
                          <label
                            className="form-check-label"
                            htmlFor="gamBackfill"
                          >
                            BackFill
                          </label>
                          <input
                            className="form-check-input"
                            id="gamBackfill"
                            type="checkbox"
                            {...form1.register("gamBackfill", {
                              required: false,
                            })}
                            value="1"
                          />
                        </div>
                        {watchGambackFill && (
                          <div className="d-flex gap-3">
                           <div className="flex flex-col">
                              <label
                                htmlFor="backfill_gam_code"
                                className="form-label"
                              >
                                Ad Code{" "}
                              </label>
                              <input
                                type="text"
                                placeholder="Enter Backfill Ad Code"
                                className="form-control w-full"
                                id="backfill_gam_code"
                                {...form1.register("backfill_gam_code", {
                                  required: watchGambackFill,
                                  onChange: () => form1.trigger("backfill_gam_code_partner")
                                })}
                              />
                              {form1.formState.errors?.backfill_gam_code && (
                                <p className="red-text">
                                  Ad code is required!
                                </p>
                              )}
                            </div>
                            <div>
                              <label className="form-label">Ad Partner</label>
                              <Controller
                                name="backfill_gam_code_partner"
                                control={form1.control}
                                rules={{
                                  validate: (value) => {
                                    if (watchBackfillGamCode && String(watchBackfillGamCode).trim() !== "") {
                                      return value && value.value ? true : "Partner required when ad code is filled";
                                    }
                                    return true;
                                  },
                                }}
                                render={({ field }) => (
                                  <Select
                                    {...field}
                                    name="backfill_gam_code_partner"
                                    options={adPartners}
                                    classNamePrefix="select"
                                    placeholder="Select Partner"
                                    onChange={(opt) => {
                                      field.onChange(opt);
                                      form1.trigger("backfill_gam_code_partner");
                                    }}
                                  />
                                )}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                       <div>
                        <div className="form-check">
                          <label
                            className="form-check-label"
                            htmlFor="gamBackfill8_87"
                          >
                            BackFill Version 8.88
                          </label>
                          <input
                            className="form-check-input"
                            id="gamBackfill8_87"
                            type="checkbox"
                            {...form1.register("gamBackfill8_87", {
                              required: false,
                            })}
                            value="1"
                          />
                        </div>
                        {watchGambackFill8_87 && (
                         
                         <div className="mt-3">
                         <label className="form-label">BackFill Source</label>
                         <br></br>
                         {BACKFILL_SOURCE.map((backfillSrc)=>(
                               <div class="form-check form-check-inline">
                           <input
                             class="form-check-input"
                             type="radio"
                             {...form1.register("backfill_gam_src8_87", { required: false })}
                             id={backfillSrc.label}
                             value={backfillSrc.value}
                           />
                           <label class="form-check-label" for={backfillSrc.label}>
                             {backfillSrc.label}
                           </label>
                         </div>
                         ))}
                       </div>
                        )}
                      </div>
                    </>
                  ) : null}
                </div>
              )}
              {
                form1.getValues("type")?.value !== "gam" && (
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      disabled={props.backfill}
                      checked={watchChecked}
                      {...form1.register("backfill", { required: false })}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Backfill
                    </label>
                  </div>
                )}
              {watchType?.value === "panel" && !props.backfill && (
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    defaultChecked={props.rotation === 1 ? true : false}
                    {...form1.register("rotation", { required: false })}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexCheckDefault"
                  >
                    Rotation
                  </label>
                </div>
              )}
            </div>
            <button
              class="btn btn-primary btn-sm mt-3"
              type="submit"
              disabled={submitClicked}
            >
              {submitClicked && (
                <span
                  className="spinner-grow spinner-grow-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
              {submitClicked ? "Submitting..." : "Submit"}
            </button>
          </form>
        </div>
      </SlDrawer>
      <Modal
        show={submitClicked}
        onHide={() => {
          setSubmitClicked(false);
          setFormData();
          setFormSubmit(false);
          props.setShow(false);
          props.fetchAds(0, props.target_filter);
          setPreviewCampaignId(null)
        }}
        backdrop="static"
        animation={false}
        dialogClassName="modal-fullwidth"
        size="xl"
        centered
      >
        <ModalHeader closeButton className="border-bottom bg-light">
              <div className="d-flex align-items-center justify-content-between w-100">
                <ModalTitle className="d-flex align-items-center mb-0">
                  <i className="fas fa-list-alt me-2 text-primary"></i>
                  <h4 className="mb-0 text-dark fw-bold">Existing Lineitems Overview</h4>
                </ModalTitle>
                {/* Action Buttons in Header */}
                <div className="d-flex gap-2 ms-3">
                  <button
                    className="btn btn-outline-danger btn-sm px-3 d-flex align-items-center"
                    type="button"
                    onClick={() => {
                      setSubmitClicked(false);
                      setFormData();
                      setFormSubmit(false);
                      props.setShow(false);
                      props.fetchAds(0, props.target_filter);
                      setPreviewCampaignId(null)
                    }}
                  >
                    <i className="fas fa-times me-1"></i>
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary btn-sm px-3 d-flex align-items-center position-relative"
                    type="submit"
                    onClick={() => {
                      setFormSubmit(true);
                      onSubmit(formData);
                    }}
                    disabled={formSubmit}
                    style={{ minWidth: '120px' }}
                  >
                    {formSubmit && (
                      <span
                        className="spinner-border spinner-border-sm me-1"
                        role="status"
                        aria-hidden="true"
                        style={{ width: '0.8rem', height: '0.8rem' }}
                      ></span>
                    )}
                    <i className={`fas ${formSubmit ? 'fa-spinner fa-spin' : 'fa-check'} me-1`}></i>
                    {formSubmit ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </div>
        </ModalHeader>
        <ModalBody className="p-4" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
              <div className="container-fluid">
                <div className="row">
                  {/* Existing Lineitems Section */}
                  <div className="col-12 mb-4">
                      <div className="card border-0 shadow-sm">
                        <div
                          className="card-header bg-gradient text-white d-flex align-items-center"
                          style={{
                            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          }}
                        >
                          <i className="fas fa-tags me-2"></i>
                          <h5 className="mb-0 fw-semibold">Lineitems & Matching Alerts</h5>
                          <span className="badge bg-light text-dark ms-auto">
                            {
                              (matchAdCodeAlert?.dfp_lineitems_alerts?.length || 0) +
                              (matchAdCodeAlert?.networkAd_alerts?.length || 0) +
                              (matchAdCodeAlert?.overlappingLineitems?.length || 0)}
                              {" "}
                            items
                          </span>
                        </div>

                        <div className="card-body p-3">

                          <div className="row g-2">

                            {/* === DFP Alerts (Yellow) === */}
                            {matchAdCodeAlert?.dfp_lineitems_alerts?.map((item, index) => (
                              <div key={`dfp-${index}`} className="col-md-6 col-lg-4 d-flex">
                                <div
                                  className="alert w-100 h-100 mb-2 border-0 shadow-sm d-flex align-items-center p-1"
                                  style={{
                                    backgroundColor: "#ede7f6",  // light violet
                                    color: "#4a148c",  
                                    fontWeight: 500,
                                  }}
                                >
                                  <i className="fas fa-exclamation-triangle me-2"></i>
                                  <span>
                                    {item.campaign_name} ({item.ad_code}) — P{item.position} {slotOptions[item.slot]}
                                  </span>
                                  <span
                                    className="badge ms-auto"
                                    style={{ backgroundColor: "#d1c4e9", color: "#4a148c" }}
                                  >
                                    DFP Match
                                  </span>
                                </div>
                              </div>
                            ))}

                            {/* === Network Ads Alerts (Red) === */}
                            {matchAdCodeAlert?.networkAd_alerts?.map((item, index) => (
                              <div key={`net-${index}`} className="col-md-6 col-lg-4 d-flex">
                                <div
                                  className="alert w-100 h-100 mb-2 border-0 shadow-sm d-flex align-items-center p-1"
                                  style={{
                                    backgroundColor: "#fff3cd",
                                    color: "#856404",
                                    fontWeight: 500,
                                  }}
                                >
                                  <i className="fas fa-exclamation-circle me-2"></i>
                                  <span>
                                    {item.ad_name} ({item.ad_code})
                                    {item.position ? ` — P${item.position}` : ""}
                                  </span>
                                  <span
                                    className="badge ms-auto"
                                    style={{ backgroundColor: "#ffeeba", color: "#856404" }}
                                  >
                                    Network Match
                                  </span>
                                </div>
                              </div>
                            ))}

                            {/* === Overlapping Audience Target Lineitems (Teal) === */}
                            {matchAdCodeAlert?.overlappingLineitems?.map((item, index) => {
                              const st = getOverlapStatus(item.status);
                              return (
                                <div key={`ov-${index}`} className="col-md-6 col-lg-4 d-flex">
                                  <div
                                    className="alert w-100 h-100 mb-2 border-0 shadow-sm d-flex align-items-center p-1"
                                    style={{
                                      backgroundColor: "#e0f2f1",
                                      color: "#004d40",
                                      fontWeight: 500,
                                    }}
                                  >
                                    <i className="fas fa-users me-2"></i>
                                    <span>{item.campaign_name}</span>
                                    <span
                                      className="badge ms-auto"
                                      style={{ backgroundColor: st.bg, color: st.color, fontSize: st.fontSize }}
                                    >
                                      {st.label}
                                    </span>
                                  </div>
                                </div>
                              );
                            })}

                            {/* === NO DATA === */}
                            {
                              (matchAdCodeAlert?.dfp_lineitems_alerts?.length || 0) === 0 &&
                              (matchAdCodeAlert?.networkAd_alerts?.length || 0) === 0 &&
                              (matchAdCodeAlert?.overlappingLineitems?.length || 0) === 0 && (
                                <div className="text-center py-4">
                                  <i className="fas fa-inbox fa-3x text-muted mb-3"></i>
                                  <h5 className="text-muted">No Lineitems Found</h5>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>

                  {/* Preview Section */}
                  {previewCampaignId && (
                    <div className="col-12 mb-4">
                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-gradient text-white d-flex align-items-center" style={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' }}>
                          <i className="fas fa-eye me-2"></i>
                          <h5 className="mb-0 fw-semibold">Lineitem Preview</h5>
                          <small className="ms-auto opacity-75">Campaign ID: {previewCampaignId}</small>
                        </div>
                        <div className="card-body p-3">
                          <div className="position-relative">
                            <LineitemPreview campaign_id={previewCampaignId} />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Action Buttons */}
                
              </div>
            </ModalBody>
      </Modal>
    </>
  );
}

export default AddPosition;
